const baseThemeStyles = {
  typography: {
    // 14 is the default for MUI, this value is used to calculate rem-based sizes for typography components.
    // If this is anything other than 14 we have subtle misalignments.
    fontSize: 14,
  },
  table: {
    backgroundColor: "#2c2c2c"
  },
  tableRow: {
    stripeColor: "#464646"
  },
  checkbox: {
    fontSize: 26
  },
};

export default baseThemeStyles;
